/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inactive/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Inactive({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/PracticeHub/Status/Inactive"
  
}) {
let patientPersonPublicUserAccountEmailValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person.public_user.account.email',
})
let constantData = '(needs to verify a/c)'
let aggregateData = fromAggregate.join(patientPersonPublicUserAccountEmailValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="patient.person.public_user.account.email"
 data="'(needs to verify a/c)'"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}